<template>
    <div style="position: relative">
        <div v-if="isShow" style="width: 50px; height: 300px; position: fixed; background: #fff; bottom: 20%; right: 5%; z-index: 999">
            <div @click="handleJump">
                <div @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 0 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 0">
                    <img src="../assets/qq/side-qq@2x2.png" v-if="selectIndex == 0" style="width: 22px; height: 24px" alt="" />
                    <img src="../assets/qq/side-qq@2x.png" v-else style="width: 22px; height: 24px" alt="" />
                    <div :class="['right_fixed_box_item_pop2', selectIndex == 0 ? 'xuanzhong_pop2' : '']">
                        <div class="QQ-item" v-for="item in QQlist" :key="item.uuid">
                            <a target="_blank" :href="`http://wpa.qq.com/msgrd?v=3&uin=${item.userQq}&site=qq&menu=yes`">
                                <img border="0" :src="`http://wpa.qq.com/pa?p=2:${item.userQq}:52`" alt="点击这里给我发消息" title="点击这里给我发消息" />
                                <div class="text">{{ item.userArea }}-{{ item.userId }}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div @click="handleJump">
                <div @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 1 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 1">
                    <img src="../assets/fixed/customer.png" v-if="selectIndex == 1" style="width: 22px; height: 18px" alt="" />
                    <img src="../assets/fixed/customer2.png" v-else style="width: 22px; height: 18px" alt="" />
                    <div :class="['right_fixed_box_item_pop', selectIndex == 1 ? 'xuanzhong_pop' : '']">联系客服</div>
                </div>
            </div>
            <div @click="to('/user')">
                <div @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 2 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 2">
                    <img src="../assets/user icon@2x.png" v-if="selectIndex == 2" style="width: 21px; height: 21px" alt="" />
                    <img src="../assets/user icon@2x1.png" v-else style="width: 21px; height: 21px" alt="" />
                    <div :class="['right_fixed_box_item_pop', selectIndex == 2 ? 'xuanzhong_pop' : '']">商城会员</div>
                </div>
            </div>

            <div @click="to('/shop_cart')">
                <div @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 3 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 3">
                    <img src="../assets/index/bott/car  icon@2x.png" v-if="selectIndex == 3" style="width: 21px; height: 21px" alt="" />
                    <img src="../assets/car  icon@2x.png" v-else style="width: 21px; height: 21px" alt="" />
                    <div :class="['right_fixed_box_item_pop', selectIndex == 3 ? 'xuanzhong_pop' : '']">购物车</div>
                    <div class="Point_box">
                        <div class="Point">{{ CartCountNum }}</div>
                    </div>
                </div>
            </div>

            <div @click="to('/collection')">
                <div @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 4 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 4">
                    <img src="../assets/index/bott/love  icon@2x.png" v-if="selectIndex == 4" style="width: 21px; height: 21px" alt="" />
                    <img src="../assets/sc2.png" v-else style="width: 21px; height: 21px" alt="" />
                    <div :class="['right_fixed_box_item_pop', selectIndex == 4 ? 'xuanzhong_pop' : '']">收藏</div>
                </div>
            </div>

            <div @click="to('/message')">
                <div @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 5 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 5">
                    <img src="../assets/index/bott/masg icon@2x.png" v-if="selectIndex == 5" style="width: 21px; height: 21px" alt="" />
                    <img src="../assets/masg icon@2x.png" v-else style="width: 21px; height: 21px" alt="" />
                    <div :class="['right_fixed_box_item_pop', selectIndex == 5 ? 'xuanzhong_pop' : '']">通知</div>
                </div>
            </div>

            <div @click="to('/add_feedback')">
                <div @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 6 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 6">
                    <img src="../assets/index/bott/sug icon@2x.png" v-if="selectIndex == 6" style="width: 21px; height: 21px" alt="" />
                    <img src="../assets/sug icon@2x.png" v-else style="width: 21px; height: 21px" alt="" />
                    <div :class="['right_fixed_box_item_pop', selectIndex == 6 ? 'xuanzhong_pop' : '']">反馈</div>
                </div>
            </div>

            <div @click="dinbu" @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 7 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 7">
                <img src="../assets/index/bott/top  icon@2x.png" v-if="selectIndex == 7" style="width: 21px; height: 10px" alt="" />
                <img src="../assets/top  icon@2x.png" v-else style="width: 21px; height: 10px" alt="" />
                <div :class="['right_fixed_box_item_pop', selectIndex == 7 ? 'xuanzhong_pop' : '']">回到顶部</div>
            </div>
            <div @click="close" @mouseout="outStyle" :class="['right_fixed_box_item', selectIndex == 8 ? 'xuanzhong_bgc' : '']" @mouseover="selectIndex = 8">
                <div>关闭</div>
                <div :class="['right_fixed_box_item_pop', selectIndex == 8 ? 'xuanzhong_pop' : '']">关闭</div>
            </div>
        </div>
        <div class="box1016">
            <div class="box1017">
                <div class="box1018">
                    <a-row>
                        <a-col :span="6" style="margin-top: 4%">
                            <img src="../assets/a1@2x.png" style="width: 60px; height: 67px; float: left; margin-left: 50px" alt="" />
                            <div class="box1019">
                                <div class="box1020" style="text-align: left; color: #000000; font-size: 14px">原装正品</div>
                                <div class="box1021" style="color: #666666; font-size: 12px; margin-top: 4%">正品保障 放心购物</div>
                            </div>
                        </a-col>
                        <a-col :span="6" style="margin-top: 4%">
                            <img src="../assets/a2@2x.png" style="width: 60px; height: 67px; float: left; margin-left: 50px" alt="" />
                            <div class="box1019">
                                <div class="box1020" style="text-align: left; color: #000000; font-size: 14px">无忧售后</div>
                                <div class="box1021" style="color: #666666; font-size: 12px; margin-top: 4%">强大团队 售后无忧</div>
                            </div>
                        </a-col>
                        <a-col :span="6" style="margin-top: 4%">
                            <img src="../assets/a3@2x.png" style="width: 60px; height: 67px; float: left; margin-left: 50px" alt="" />
                            <div class="box1019">
                                <div class="box1020" style="text-align: left; color: #000000; font-size: 14px">品种丰富</div>
                                <div class="box1021" style="color: #666666; font-size: 12px; margin-top: 4%">海量品牌 放心购物</div>
                            </div>
                        </a-col>
                        <a-col :span="6" style="margin-top: 4%">
                            <img src="../assets/a4@2x.png" style="width: 60px; height: 67px; float: left; margin-left: 50px" alt="" />
                            <div class="box1019">
                                <div class="box1020" style="text-align: left; color: #000000; font-size: 14px">下单返积分</div>
                                <div class="box1021" style="color: #666666; font-size: 12px; margin-top: 4%">积分兑换 优惠多多</div>
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </div>

            <div style="width: 100%; height: 240px; background: #eaeaea">
                <div style="width: 1200px; margin: auto; height: 100%; margin: auto">
                    <img src="../assets/logo1.png" style="width: 100px; height: 100px; float: left; margin-top: 4%" alt="" />
                    <div style="overflow: hidden;  height: 240px; padding-top: 4%; float: left; width: 50%; margin-left: 2%">
                        <div style="overflow: hidden">
                            <router-link to="/about_us"><div class="box1026">关于我们</div></router-link>
                            <router-link to="/service_support"><div class="box1026">服务与支持</div></router-link>
                            <router-link to="/ordering_guide"><div class="box1026">订购指南</div></router-link>
                            <a href="http://www.chronchem.com/cn/" target="_blank"><div class="box1026">友情链接到官网</div></a>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%">
                            <router-link to="/reference_material"><div class="box1026">参考资料</div></router-link>
                            <router-link to="/return_policy"><div class="box1026">退换货流程说明</div></router-link>
                        </div>

                        <div class="cert">
                            <!-- <div class="certitem">
                                <img class="certimg" src="../assets/gongshang-logo.png" />
                                <a class="hrefColor" href="" target="_blank">工商网监</a>
                            </div> -->
                            <div class="certitem">
                                <img class="certimg" src="../assets/danger-logo.png" />
                                <a class="hrefColor" href="http://www.cdkelongchem.com/upload/%E5%8D%B1%E9%99%A9%E5%8C%96%E5%AD%A6%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%E5%89%AF%E6%9C%AC.pdf" target="_blank">危险化学品经营许可证</a>
                            </div>
                            <div class="certitem">
                                <img class="certimg" src="../assets/zhizhao-logo.png" />
                                <a class="hrefColor" href="http://www.cdkelongchem.com/upload/%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7%E5%89%AF%E6%9C%AC.pdf" target="_blank">营业执照（三证合一）</a>
                            </div>
                            <div class="certitem">
                                <img class="certimg" src="../assets/industry-logo.png" />
                                <a class="hrefColor" href="http://www.cdkelongchem.com/upload/%E5%85%A8%E5%9B%BD%E5%B7%A5%E4%B8%9A%E7%94%9F%E4%BA%A7%E8%AE%B8%E5%8F%AF%E8%AF%81.pdf" target="_blank">工业生产许可证</a>
                            </div>
                        </div>
                    </div>

                    <div style="float: left; margin-top: 4%; overflow: hidden; width: 10%">
                        <div style="float: left">
                            <template v-if="description && description.officialAccount">
                                <img :src="'/api/file/preview/' + description.officialAccount" style="width: 100px; height: 100px" alt="" />
                                <p class="box1027">关注科隆化学公众号</p>
                            </template>
                        </div>
                        <!-- 客户要求先隐藏小程序二维码 -->
                        <!-- <div style="float: left; margin-left: 4%">
                            <template v-if="description && description.miniProgram">
                                <img :src="'/api/file/preview/' + description.miniProgram" style="width: 100px; height: 100px" alt="" />
                                <p class="box1027">进入科隆商城小程序</p>
                            </template>
                        </div> -->
                    </div>

                    <div style="float: right; margin-top: 4%;  width: 280px">
                        <div class="box1028 box" style="overflow: hidden; display: flex; align-items: flex-end">
                            <img src="../assets/qq1.png" style="width: 20px; height: 20px; float: left; margin-right: 5px; margin-top: 5px; margin-left: 50px" alt="" />
                            <span style="float: left">
                                QQ客服：
                                {{ description ? description.qq : '' }}
                            </span>
                        </div>
                        <div class="box1028" style="font-size: 20px; margin-top: 4%; overflow: hidden">
                            <img src="../assets/phone1.png" style="width: 20px; height: 20px; float: left; margin-right: 5px; margin-top: 5px; margin-left: 50px" alt="" />
                            <span style="float: left">
                                {{ description ? description.tel : '' }}
                            </span>
                        </div>
                        <div class="box1028" style="font-size: 14px; color: #666666; margin-top: 4%; margin-left: 55px; width: 300px">周一至周五 09:00-18:00（仅收市话费）</div>
                        <div class="box1028" style="font-size: 14px; color: #666666; margin-top: 4%; margin-left: 55px; width: 251px">厂区地址：四川省邛崃市羊安工业园区羊横五线十六号</div>
                    </div>
                </div>
                <!-- <div class="buttom_txt1">{{ description ? description.filingInfo : '' }}</div> -->
                <div class="buttom_txt1">
                    Copyright© 2000-2018 eBiotrade.com, All Rights Reserved <a href="https://www.beian.gov.cn/portal/recordQuery?token=49ff9b83-b5e4-4aff-9b7e-901f026e10ae" target="_blank" style="color: #2c3e50">川公网安备 51018302000037号</a>
                    <a href="https://www.cnzz.com/stat/website.php?web_id=1281102242" target="_blank" title="站长统计"> <img style="height:16px;" src="https://icon.cnzz.com/img/pic2.gif" alt=""/></a>
                    <span id="zhan_zhang"></span>
                    <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #2c3e50">蜀ICP备14015738号-4</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            isShow: true,
            selectIndex: null,
            description: null,
            QQlist: [],
            CartCountNum: 0 // 购物车数量
        };
    },
    created() {
        this._getInfoFun();
        this.getQQlist();
        this.updateCartCountFun();
    },
    watch: {
        updateCartCount() {
            this.updateCartCountFun();
        }
    },
    computed: {
        updateCartCount() {
            return this.$store.getters.updateCartCount;
        }
    },
    methods: {
        getQQlist() {
            this.api
                .getQQListAll()
                .then(result => {
                    this.QQlist = result.data;
                })
                .catch(err => {});
        },
        to(path) {
            if (window.localStorage.uuid) {
                this.$router.push(path);
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        },
        dinbu() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        close() {
            this.isShow = false;
        },
        // selectStyle(e) {
        //     this.selectIndex = e
        // },
        outStyle() {
            this.selectIndex = null;
        },
        handleJump() {
            let userId = JSON.parse(localStorage.getItem('user_info'));
            let storeId = 'e554062a-83d0-44db-ad88-590818c7fe23';
            console.log(userId);
            if (userId != null) {
                this.api.isOpen(storeId).then(res => {
                    if (res.ok == true) {
                        if (window.localStorage.user_info) {
                            window.open(`/cus/#/client?storeId=e554062a-83d0-44db-ad88-590818c7fe23&entranceId=75b1dd5d-cea2-4042-bdb8-ce74a9eceaf2&userId=${userId.uuid}`);
                            let list = {
                                storeId: 'e554062a-83d0-44db-ad88-590818c7fe23',
                                userId: userId.uuid
                            };
                            this.api.tiaozhuan(list).then(res => {});
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        },
        // 公共配置信息
        _getInfoFun() {
            let other_config = window.sessionStorage.other_config;
            if (other_config) {
                other_config = JSON.parse(other_config);
                this.description = other_config;
            } else {
                this.api.get_public_Info().then(res => {
                    if (res.data && res.data.description) {
                        let other_config = res.data.description;
                        if (other_config) {
                            other_config = JSON.parse(other_config);
                            this.description = other_config;
                        }
                    }
                });
            }
        },
        // 刷新购物车数量
        updateCartCountFun() {
            // 未登录不调用购物车数量的接口
            var newdata = JSON.parse(localStorage.getItem('user_info'));
            if (newdata) {
                this.CartCountNum = 0;
                this.api.get_cart_count().then(res => {
                    this.CartCountNum = res.data;
                });
            } else {
                console.log('未登录不请求购物车数量的接口');
            }
        }
    }
};
</script>

<style scoped>
@import '../css/App.css';
</style>

<style scoped>
.cert {
    padding: 20px 0px 0px 0px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    line-height: 20px;
}
.hrefColor {
    color: #333333;
}
.hrefColor:hover {
    color: #2b9a34;
}

.certitem {
    font-size: 14px;
    margin: 0px 5px 0px 5px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.certimg {
    width: 20px;
    margin-right: 5px;
}

.xuanzhong_bgc {
    background: #2b9a34 !important;
}

.right_fixed_box_item_pop {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 50px;
    height: 50px;
    text-align: center;
    background: #2b9a34;
    position: absolute;
    top: 0;
    right: 50px;
    width: 0;
    transition: all 0.5s;
    cursor: pointer;
    overflow: hidden;
}
.right_fixed_box_item_pop2 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 50px;
    min-height: 50px;
    /* text-align: center; */
    background: #2b9a34;
    position: absolute;
    top: 0;
    right: 50px;
    width: 0;
    transition: all 0.5s;
    cursor: pointer;
    overflow: hidden;
}

.right_fixed_box_item {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #e8e6e6;
    position: relative;
    cursor: pointer;
}

.Point_box {
    position: relative;
}
.Point_box > .Point {
    position: absolute;
    top: -20px;
    right: -12px;
    text-align: center;
    /* background: #2c9a34; */
    background: red;
    border-radius: 7px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    padding: 2px 5px;
    height: 14px;
    line-height: 10px;
}
.buttom_txt1 {
    background: #bebebe;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.ant-input-search-button {
    background: #2b9a34 !important;
    border: none !important;
    height: 40px;
    width: 60px;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    padding: 0;
    /* overflow: hidden; */
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
}

body {
    padding: 0 !important;
    margin: 0 !important;
    /* overflow: hidden; */
    width: 100%;
    height: 100%;
    position: relative !important;
}

html,
body,
#app {
    height: 100%;
    padding: 0;
    margin: 0;
}

.xuanzhong_pop {
    width: 75px;
}
.xuanzhong_pop2 {
    width: 200px;
}

.QQ-item {
    margin-top: 10px;
}
.QQ-item a {
    display: flex;
    padding: 0 10px;
    align-items: center;
}
.QQ-item a img {
    flex-shrink: 0;
    width: 25px;
    height: 25px;
    margin-right: 5px;
}
.QQ-item .text {
    width: 220px;
    color: #fff;
    white-space: nowrap; /* 规定文本是否折行 */
    overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/public/foot.vue